import { render, staticRenderFns } from "./VacateInfo.vue?vue&type=template&id=06fc03c2&scoped=true"
import script from "./VacateInfo.vue?vue&type=script&lang=js"
export * from "./VacateInfo.vue?vue&type=script&lang=js"
import style0 from "./VacateInfo.vue?vue&type=style&index=0&id=06fc03c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc03c2",
  null
  
)

export default component.exports